var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"primary","absolute":"","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© 2026")]),_c('v-spacer'),_c('span',{staticClass:"white--text"},[_vm._v("version "),_c('span',{attrs:{"id":"app-version"}},[_vm._v(_vm._s(_vm.version))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }